<div class="acc-surveys-by-specialist-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="surveysBySpecialist()"></grid-content>
</div>